import { render, staticRenderFns } from "./CardVideo.vue?vue&type=template&id=90620706"
import script from "./CardVideo.vue?vue&type=script&lang=js"
export * from "./CardVideo.vue?vue&type=script&lang=js"
import style0 from "./CardVideo.vue?vue&type=style&index=0&id=90620706&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports